import { EntryType } from '@/utils';
import React from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { JsonView } from '@/components/atom';
import styles from './dataView.module.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TAB_SIZE = 3;
export default class DataView extends React.PureComponent {
  static get propTypes() {
    return {
      entry: EntryType
    };
  }
  static get defaultProps() {
    return {
      entry: null
    };
  }
  get messages() {
    const {
      messages
    } = this.props.entry;
    return messages.length > 1 ? messages : messages[0];
  }
  constructor(props) {
    super(props);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.state = {
      tabIndex: 0
    };
  }
  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown);
  }
  render() {
    const {
      tabIndex
    } = this.state;
    const {
      entry
    } = this.props;
    if (!entry) {
      return null;
    }
    const [args, payload] = this._getState();
    return /*#__PURE__*/_jsxs(Tabs, {
      selectedIndex: tabIndex,
      onSelect: tabIndex => this.setState({
        tabIndex
      }),
      children: [/*#__PURE__*/_jsxs(TabList, {
        children: [/*#__PURE__*/_jsx(Tab, {
          children: "Args"
        }), /*#__PURE__*/_jsx(Tab, {
          children: "Payload"
        }), /*#__PURE__*/_jsx(Tab, {
          children: "Events"
        })]
      }), /*#__PURE__*/_jsx(TabPanel, {
        children: args ? /*#__PURE__*/_jsx(JsonView, {
          src: args,
          collapse: 3
        }) : /*#__PURE__*/_jsx("div", {
          className: styles.info,
          children: "Event's args are empty"
        })
      }), /*#__PURE__*/_jsx(TabPanel, {
        children: payload ? /*#__PURE__*/_jsx(JsonView, {
          src: payload,
          collapse: 3
        }) : /*#__PURE__*/_jsx("div", {
          className: styles.info,
          children: "Event's payload is empty"
        })
      }), /*#__PURE__*/_jsx(TabPanel, {
        children: /*#__PURE__*/_jsx(JsonView, {
          src: this.messages,
          collapse: 4
        })
      })]
    });
  }
  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
  }
  onKeyDown({
    keyCode
  }) {
    const {
      tabIndex
    } = this.state;
    if (keyCode === 37 && tabIndex > 0) {
      // Arrow left
      this.setState({
        tabIndex: tabIndex - 1
      });
    } else if (keyCode === 39 && tabIndex + 1 < TAB_SIZE) {
      // Arrow right
      this.setState({
        tabIndex: tabIndex + 1
      });
    }
  }
  _getState() {
    const {
      messages
    } = this.props.entry;
    const {
      state
    } = messages[Math.max(messages.length - 1, 0)].payload;
    return ['args', 'payload'].map(key => {
      return state && state[key] && (Array.isArray(state[key]) && state[key].length > 0 || Object.keys(state[key]).length > 0) ? state[key] : null;
    });
  }
}